<template>
  <div>
    <div>
      <LinkEntity :payload="payload" :additional_data="{ resource_type: 'Position' }" />
    </div>
    <br />
    <div>
      <ResourceTextEditor :is_flex="false" :payload="{ text_data: salary_expectation, designator: 'salary_expectations', resource_type: 'Position', resource_id: payload.id, company_id: payload.company.resource_id }" />
    </div>
  </div>
</template>
<script>
import LinkEntity from '@/components/LinkEntity'
import ResourceTextEditor from '@/components/ResourceTextEditor.vue'

export default {
  name: 'TableCellFullName',
  components: {
    ResourceTextEditor,
    LinkEntity
  },
  props: {
    payload: {
      type: Object
    },
    additional_data: {
      type: Object
    }
  },
  data () {
    return {
      salary_expectation: {}
    }
  },
  created () {
    this.getPositionTexts()
  },
  methods: {
    getPositionTexts () {
      this.$network_utils.getResourceTexts({
        current_type: 'Position',
        current_resource_id: this.payload.id
      }).then(response => {
        this.salary_expectation = response.find(r => r.designator == 'salary_expectations')
      })
    }
  }
}
</script>
